module.exports = __webpack_public_path__ + "img/积压.9927c1b3.svg";